import { render, staticRenderFns } from "./PreOrdersTable.vue?vue&type=template&id=2661625d&scoped=true&"
import script from "./PreOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PreOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661625d",
  null
  
)

export default component.exports